import { defineStore } from "pinia";

interface ActionModalModel {
  title: string;
  message: string;
  secondMessage?: string;
  contactSupport: boolean;
  type: string;
  error?: string;
}

interface State {
  showLoginModal: boolean;
  showActionModal: boolean;
  showConfirmLeaveModal: boolean;
  showRegistrationNotCompleteModal: boolean;
  showLeaveCompanyModal: boolean;
  userCompanyInviteCode: string | undefined; // if set it shows the user company invite modal
  actionModal: ActionModalModel;
  loginRedirectLink: string | null;
  becomeDeveloperAfterLogin: boolean;
  isFormDirty: boolean; // only works with 1 form per page
  userClickedBecomeContributor: boolean;
}

export const useUiStore = defineStore("ui", {
  state: (): State => ({
    showLoginModal: false,
    showActionModal: false,
    showConfirmLeaveModal: false,
    showLeaveCompanyModal: false,
    showRegistrationNotCompleteModal: false,
    userCompanyInviteCode: undefined,
    actionModal: {
      title: "",
      message: "",
      contactSupport: false,
      type: "",
    },
    loginRedirectLink: null,
    becomeDeveloperAfterLogin: false,
    isFormDirty: false,
    userClickedBecomeContributor: false,
  }),
  getters: {
    isLargeScreen(): boolean {
      return typeof window !== "undefined" && window.innerWidth >= 768;
    },
  },
  actions: {
    async checkBrowserCompatibility() {
      const supportedBrowsers = ["Firefox", "Chrome"];
      const userAgent = navigator.userAgent;
      let supported = false;
      for (const browser of supportedBrowsers) {
        if (browser && userAgent.includes(browser)) {
          supported = true;
          break;
        }
      }

      if (!supported) {
        this.setMessage({
          title: "Your browser is not supported.",
          message:
            "It looks as if you are using a browser that is currently not supported by PLCnext Store. \n Unforeseen (optical) appearances may occur.",
          secondMessage:
            "To ensure functionality of PLCnext Store please use Chrome or Firefox.",
          type: "success",
          contactSupport: false,
        });
      }
    },

    setMessage(msg: ActionModalModel) {
      this.actionModal.title = msg.title;
      this.actionModal.message = msg.message;
      this.actionModal.secondMessage = msg.secondMessage;
      this.actionModal.error = msg.error;
      this.actionModal.contactSupport = msg.contactSupport;
      this.actionModal.type = msg.type;
      this.showActionModal = true;
      console.debug("setMessage");
    },

    setMessageWithTitleMessageAndType(
      title: string,
      message: string,
      type: string,
    ) {
      this.actionModal.title = title;
      this.actionModal.message = message;
      this.actionModal.secondMessage = undefined;
      this.actionModal.error = undefined;
      this.actionModal.contactSupport = false;
      this.actionModal.type = type;
      this.showActionModal = true;
      console.debug("setMessageWithTitleMessageAndType");
    },

    clearActionModal() {
      this.showActionModal = false;
      this.actionModal = {
        title: "",
        message: "",
        contactSupport: false,
        type: "",
      };
    },

    clear() {
      this.$reset();
    },
  },
});
